import React, { useState } from 'react';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonMenuButton,
  IonSegment,
  IonSegmentButton,
  IonLabel,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonList,
  IonItem,
  IonToggle,
  IonSelect,
  IonSelectOption,
  IonIcon,
} from '@ionic/react';
import { 
  personOutline, 
  notificationsOutline, 
  linkOutline,
  shieldOutline,
  colorPaletteOutline,
  languageOutline,
} from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import GoogleIntegration from '../components/GoogleIntegration';

const Settings: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [selectedTab, setSelectedTab] = useState('integrations');

  // Check for tab param in URL
  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab) {
      setSelectedTab(tab);
    }
  }, []);

  const renderContent = () => {
    switch (selectedTab) {
      case 'profile':
        return (
          <IonCard>
            <IonCardHeader>
              <IonCardTitle className="flex items-center">
                <IonIcon icon={personOutline} className="mr-2" />
                Profile Settings
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <p className="text-gray-600 dark:text-gray-400">
                Profile settings coming soon...
              </p>
            </IonCardContent>
          </IonCard>
        );

      case 'notifications':
        return (
          <IonCard>
            <IonCardHeader>
              <IonCardTitle className="flex items-center">
                <IonIcon icon={notificationsOutline} className="mr-2" />
                Notification Preferences
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                <IonItem>
                  <IonLabel>Email Notifications</IonLabel>
                  <IonToggle slot="end" />
                </IonItem>
                <IonItem>
                  <IonLabel>Push Notifications</IonLabel>
                  <IonToggle slot="end" />
                </IonItem>
                <IonItem>
                  <IonLabel>New Ticket Alerts</IonLabel>
                  <IonToggle slot="end" checked />
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>
        );

      case 'integrations':
        return <GoogleIntegration />;

      case 'appearance':
        return (
          <IonCard>
            <IonCardHeader>
              <IonCardTitle className="flex items-center">
                <IonIcon icon={colorPaletteOutline} className="mr-2" />
                Appearance
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                <IonItem>
                  <IonLabel>Theme</IonLabel>
                  <IonSelect value="system" slot="end">
                    <IonSelectOption value="light">Light</IonSelectOption>
                    <IonSelectOption value="dark">Dark</IonSelectOption>
                    <IonSelectOption value="system">System</IonSelectOption>
                  </IonSelect>
                </IonItem>
                <IonItem>
                  <IonLabel>Language</IonLabel>
                  <IonSelect 
                    value={i18n.language} 
                    onIonChange={(e) => i18n.changeLanguage(e.detail.value)}
                    slot="end"
                  >
                    <IonSelectOption value="en">English</IonSelectOption>
                    <IonSelectOption value="he">עברית</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </IonList>
            </IonCardContent>
          </IonCard>
        );

      case 'privacy':
        return (
          <IonCard>
            <IonCardHeader>
              <IonCardTitle className="flex items-center">
                <IonIcon icon={shieldOutline} className="mr-2" />
                Privacy & Security
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <p className="text-gray-600 dark:text-gray-400">
                Privacy settings coming soon...
              </p>
            </IonCardContent>
          </IonCard>
        );

      default:
        return null;
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton menu="main-menu" />
          </IonButtons>
          <IonTitle>{t('common.settings')}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-4xl mx-auto p-4">
          <IonSegment 
            value={selectedTab} 
            onIonChange={(e) => setSelectedTab(e.detail.value as string)}
            className="mb-6"
          >
            <IonSegmentButton value="profile">
              <IonLabel>Profile</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="notifications">
              <IonLabel>Notifications</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="integrations">
              <IonLabel>Integrations</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="appearance">
              <IonLabel>Appearance</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="privacy">
              <IonLabel>Privacy</IonLabel>
            </IonSegmentButton>
          </IonSegment>

          {renderContent()}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Settings;